import { Injectable } from '@angular/core';
import { AuthService } from 'angularx-social-login';
import { environment } from 'src/environments/environment';
import { CartService } from './api/cart.service';
import { MainService } from './api/main.service';
import { LangService } from './lang/lang.service';
import { SessionService } from './session.service';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})


// https://developers.google.com/identity/gsi/web/reference/js-reference
// https://console.cloud.google.com/apis/dashboard?project=entrelabel-1590398351267&show=all

export class SocialLoginService {

	googleAccount:any;

	constructor(
		public sessionService: SessionService,
		public mainService: MainService,
		public lang: LangService,
		public storage: StorageService,
		public cartService: CartService,
		public authService: AuthService
	) {
		this.setGoogleAccount();
	}

	setGoogleAccount(){
		let check = setInterval(f=>{
			if(typeof window['google'] != 'undefined'){
				if(typeof window['google']['accounts'] != 'undefined'){
					this.googleAccount = window.google['accounts'];
		
					this.googleAccount.id.initialize({
						client_id: environment.social_login.google_id,
						callback: (result) => {
							this.googleSignExtractToken(result);
						},
						cancel_on_tap_outside: true
					});
					// this.promt();

					clearInterval(check);
				}
			}
		}, 500);
	}

	promt(notification:any = null){
		if (!this.sessionService.user.isLogedIn) {
			this.googleAccount.id.prompt(notification);
		}
		
		// this.googleAccount.id.prompt((notification) => {
			// if (notification.isNotDisplayed() || notification.isSkippedMoment()) {
			// }
		// });
	}

	googleSignExtractToken(result) {
		let token = result['credential'];

		let jsonData = {
			input_token: token,
			"provider": "GOOGLE"
		} 
		this.socialLogin(jsonData);
	}

	/**
	 * get token of the user
	 */
	login(email, password) {
		return new Promise(res => {
			this.mainService.setLoader(true);
			let formData = new FormData();
			formData.append("username", email);
			formData.append("password", password);

			// this.mainService.post("/rest/entrelable/V1/integration/customer/token", formData).subscribe(
			this.mainService.post("/rest/entrelable/V1/hnd-customer/login", formData).subscribe(
				(success) => {
					let user = {
						token: success,
						isLogedIn: true,
					};
					
					this.storage.setLocal("user", user, null);
					this.assignGuestCartToCustomer();
					res(true);
				},
				(error) => {
					this.mainService.errorHandler(error);
					res(false);
				}
			);
		});
	}

	/**
	 * login user in either google or facebook
	 */
	 socialLogin(result) {
		let url = this.mainService.getStoreUrl("/V1/lns-sociallogin/socialcustomer");
		this.mainService.post(url, result).subscribe(
			(check) => {
				let customer = check[0];
				let user = {
					token: customer.data.token,
					isLogedIn: true,
				};
				this.storage.setLocal("user", user, null);
				this.assignGuestCartToCustomer();
			},
			(error) => this.mainService.errorHandler(error)
		);




		// if (!result.email) {
		// 	this.mainService.toastService.add(this.lang.getLang("l34"), "info");
		// } else {
		// 	this.mainService.setLoader(true);

		// 	let header = {
		// 		"Content-Type": "application/json; charset=utf-8",
		// 	};

		// 	let _firstName:any = '';
		// 	if(typeof result.firstname != 'undefined'){
		// 		_firstName = result.firstname;
		// 	}
		// 	else if(typeof result.firstName != 'undefined'){
		// 		_firstName = result.firstName;
		// 	}

		// 	let _lastName:any = '';
		// 	if(typeof result.firstname != 'undefined'){
		// 		_lastName = result.lastname;
		// 	}
		// 	else if(typeof result.firstName != 'undefined'){
		// 		_lastName = result.lastName;
		// 	}

		// 	let password = this.makeid(16);
		// 	let jsonData = {
		// 		customer: {
		// 			store_id: 2,
		// 			email: result.email,
		// 			firstname: _firstName,
		// 			lastname: _lastName,
		// 			addresses: [],
		// 		},
		// 		password: password,
		// 	};

		// 	// let url = "/rest/entrelable/V1/lns-sociallogin/socialcustomer";
		// 	let url = this.mainService.getStoreUrl("/V1/lns-sociallogin/socialcustomer");
		// 	url += "?social_id=" + result.id;
		// 	url += "&type=" + result.provider;
		// 	url += "&email=" + result.email;
		// 	url += "&provider=" + result.provider;

		// 	this.mainService.get(url).subscribe(
		// 		(check) => {
		// 			let customer = check[0];


		// 			if (customer.error == 1) {
		// 				// this.mainService.post("/rest/entrelable/V1/customers",JSON.stringify(jsonData),header)
		// 				this.mainService.post(this.mainService.getStoreUrl("/V1/customers"),JSON.stringify(jsonData),header)
		// 				.subscribe(
		// 					(success) => {
		// 					result["customer_id"] = success.id;

		// 						// this.mainService.post("/rest/entrelable/V1/lns-sociallogin/sociallogin", JSON.stringify(result), header)
		// 						this.mainService.post(this.mainService.getStoreUrl("/V1/lns-sociallogin/sociallogin"), JSON.stringify(result), header)
		// 						.subscribe(
		// 							(saveSocialCustomer) => {
		// 								this.login(result.email, password)
		// 							},
		// 							(error) => this.mainService.errorHandler(error)
		// 						);
		// 					},
		// 					(error) => {
		// 						this.mainService.setLoader(false);
		// 						this.mainService.toastService.add(error.error.message,"danger");
		// 						this.signOut();
		// 					}
		// 				);
		// 			} else {
		// 				let user = {
		// 					token: customer.data.token,
		// 					isLogedIn: true,
		// 				};
		// 				this.storage.setLocal("user", user, null);
		// 				this.assignGuestCartToCustomer();
		// 			}
		// 		},
		// 		(error) => this.mainService.errorHandler(error)
		// 	);
		// }
	}

	assignGuestCartToCustomer() {
		this.mainService.makeRequest("/rest/entrelable/V1/customers/me", "", "GET").then((customer) => {
			this.storage.get("guest_cart_id").then((guestCartId) => {
				if (guestCartId) {
					let c: any = customer;
					let jsonData = {
						customerId: c.id,
						storeId: c.store_id,
					};
					this.mainService.makeRequest("/rest/entrelable/V1/guest-carts/" + guestCartId, jsonData, "PUT", false)
					.then((assingedCart) => {
						this.storage.removeItem("guest_cart_id");
						this.getCartIdAndSetUserData(customer);
					});
				} else {
					this.getCartIdAndSetUserData(customer);
				}
			});
		});
	}

	getCartIdAndSetUserData(customer) {
		window.location.reload();
		// this.cartService.getCart().then((cart) => {
		// 	this.sessionService.userData = customer;
		// 	this.mainService.setLoader(false);
		// 	this.sessionService.checkLogin();
		// 	window.location.reload();
		// });
	}

	signOut(): void {
		this.authService.signOut();
	}
	

	/**
	 * generate a random string for password
	 */
	makeid(length) {
		let result = "";
		let characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
		let charactersLength = characters.length;
		for (var i = 0; i < length; i++) {
			result += characters.charAt(Math.floor(Math.random() * charactersLength));
		}
		return result;
	}
}
